import { useEffect, useState } from 'react';

export default function useHasScrolledPast(
  elementRef: React.RefObject<HTMLElement>,
  topOffset = 0
) {
  const [hasScrolledPast, setHasScrolledPast] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return;

        const elementLocationInView = entry.boundingClientRect.y;

        setHasScrolledPast(elementLocationInView < topOffset);
      },
      {
        rootMargin: `-${topOffset}px 0px 0px 0px`,
        threshold: topOffset ? 1 : 0
      }
    );

    if (elementRef.current) observer.observe(elementRef.current);

    return () => observer.disconnect();
  }, [elementRef, topOffset]);

  return hasScrolledPast;
}
